import { Instagram, Facebook, Mail, Globe, MessageCircle } from "lucide-react";

const TikTok = (p) => (
  <svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor" {...p}><path d="M16.6 5.82A4.28 4.28 0 0 1 15.54 3h-3.09v12.4a2.59 2.59 0 0 1-2.59 2.5 2.6 2.6 0 0 1-2.6-2.6 2.6 2.6 0 0 1 3.37-2.48V9.66a5.7 5.7 0 0 0-.77-.05A5.69 5.69 0 0 0 4.17 15.3 5.69 5.69 0 0 0 9.86 21a5.69 5.69 0 0 0 5.69-5.69V9.01a7.35 7.35 0 0 0 4.3 1.38V7.3a4.3 4.3 0 0 1-3.25-1.48z" /></svg>
);
const XLogo = (p) => (
  <svg viewBox="0 0 24 24" width="16" height="16" fill="currentColor" {...p}><path d="M18.24 2.25h3.31l-7.23 8.26 8.5 11.24h-6.65l-5.21-6.82-5.97 6.82H1.68l7.73-8.84L1.25 2.25h6.82l4.71 6.23zm-1.16 17.52h1.83L7.08 4.13H5.12z" /></svg>
);

const SOCIALS = [
  { name: "Facebook", href: "https://www.facebook.com/share/1JW6Bg9Met/?mibextid=wwXIfr", Icon: (p) => <Facebook size={18} {...p} /> },
  { name: "Instagram", href: "https://www.instagram.com/mlobox.ke/", Icon: (p) => <Instagram size={18} {...p} /> },
  { name: "TikTok", href: "https://www.tiktok.com/@mlobox.foods", Icon: TikTok },
  { name: "X", href: "https://x.com/mloboxfoods", Icon: XLogo },
];

export default function SiteFooter() {
  return (
    <footer data-testid="site-footer" className="mt-16 bg-[#111111] text-white/70 text-sm border-t-4 border-[#FF6600]">
      <div className="max-w-6xl mx-auto px-4 py-8 grid gap-6 sm:grid-cols-3">
        <div className="flex items-start gap-3">
          <img src="/logo192.png" alt="MLOBOX" className="h-10 w-10 rounded-lg" />
          <div>
            <div className="font-display font-extrabold text-white">MLOBOX</div>
            <div className="text-xs tracking-widest text-[#FF8A3D] mt-0.5">TASTE THE COMFORT OF HOME</div>
          </div>
        </div>
        <div className="space-y-2">
          <a href="https://wa.me/254742847610" target="_blank" rel="noreferrer" data-testid="footer-whatsapp" className="flex items-center gap-2 hover:text-[#FF8A3D]"><MessageCircle size={16} /> WhatsApp / Call: +254 742 847 610</a>
          <a href="mailto:info@mloboxgo.com" data-testid="footer-email" className="flex items-center gap-2 hover:text-[#FF8A3D]"><Mail size={16} /> info@mloboxgo.com</a>
          <a href="https://mloboxgo.com" data-testid="footer-website" className="flex items-center gap-2 hover:text-[#FF8A3D]"><Globe size={16} /> mloboxgo.com</a>
        </div>
        <div>
          <div className="text-white font-semibold mb-2">Follow us</div>
          <div className="flex gap-2">
            {SOCIALS.map(({ name, href, Icon }) => (
              <a key={name} href={href} target="_blank" rel="noreferrer" aria-label={name} data-testid={`footer-social-${name.toLowerCase()}`}
                className="h-10 w-10 rounded-full bg-white/10 grid place-items-center text-white hover:bg-[#FF6600] transition-colors">
                <Icon />
              </a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}
